let ControllerName = 'Courses';
const CourseControllers = Object.freeze({
    AllCoursesData: `${ControllerName}/basic-courses-paginated`,
    CourseById: `${ControllerName}/course-by-slug`, //`${ControllerName}/course-by-id`
    LatestCoursesMenu : `${ControllerName}/latest-courses`,
    SimilarCourses : `${ControllerName}/similar-courses`,
});

export default CourseControllers;